import { PeekdataApi } from "peekdata-datagateway-api-sdk";
import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import SmoothCollapse from "react-smooth-collapse";
import { Prism } from "react-syntax-highlighter";
import { dataapi } from "src/constants/dataapi";

const peekdataApi = new PeekdataApi({
  baseUrl: dataapi.apiUrl,
  timeout: 60000,
});

// #region -------------- Code -------------------------------------------------------------------

const colorsCode: string = JSON.stringify(dataapi.colors);

const requestCode: string = JSON.stringify(dataapi.request, null, 2)
  .replace(/"([^"]+)":/g, "$1:")
  .replace(/\"EQUALS\"/g, "ReportFilterOperationType.EQUALS")
  .replace(/\"ASC\"/g, "ReportSortDirectionType.ASC");

// #endregion

// #region -------------- Interfaces --------------------------------------------------------------

interface IProps {
  component: JSX.Element;
  code: string;
  title?: string;
}

interface IState {
  isExpanded: boolean;
  selectResponse: string;
  dataOptimizedResponse: string;
}

// #endregion

// #region -------------- Component ---------------------------------------------------------------

export class ExampleChart extends React.PureComponent<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      isExpanded: true,
      selectResponse: null,
      dataOptimizedResponse: null,
    };
  }

  public componentDidMount() {
    const reportRequest = dataapi.request;
    if (reportRequest) {
      peekdataApi.data.getQuery(reportRequest).then((response) => {
        this.setState({ selectResponse: response });
      });

      peekdataApi.data.getDataOptimized(reportRequest).then((response) => {
        this.setState({
          dataOptimizedResponse: JSON.stringify(response, null, 2),
        });
      });
    }
  }

  public render() {
    const { component } = this.props;
    return (
      <div className="pd-example-chart-container">
        {this.renderTitle()}

        <div>
          <div className="pd-example-chart-wrapper col-md-6">
            <div>{component}</div>
          </div>
          <div className="col-md-6">{this.renderTabs()}</div>
        </div>
      </div>
    );
  }

  // #region -------------- Title -------------------------------------------------------------------

  private renderTitle() {
    const { title } = this.props;

    if (!title) {
      return null;
    }

    return (
      <div className="pd-title pd-title-dark pd-title-extra-small">{title}</div>
    );
  }

  // #endregion

  // #region -------------- Tabs -------------------------------------------------------------------

  private renderTabs() {
    const { isExpanded, selectResponse, dataOptimizedResponse } = this.state;
    const { code } = this.props;

    return (
      <SmoothCollapse expanded={isExpanded}>
        <Tabs
          id="pd-example-chart-tabs"
          className="pd-tabs pd-example-chart-tabs"
          mountOnEnter={true}
          style={{ height: "400px", overflow: "scroll" }}
        >
          <Tab eventKey={0} title="Code" tabClassName="pd-tab">
            <div className="pd-example-code">
              <Prism language="javascript">{getCode(code)}</Prism>
            </div>
          </Tab>
          <Tab eventKey={3} title="API Request" tabClassName="pd-tab">
            <div className="pd-example-code">
              <Prism language="bash">{dataapi.curlRequest}</Prism>
            </div>
          </Tab>
          <Tab eventKey={2} title="API Response" tabClassName="pd-tab">
            <div className="pd-example-code">
              <Prism language="json">{dataOptimizedResponse}</Prism>
            </div>
          </Tab>
          <Tab eventKey={1} title="Generated SQL" tabClassName="pd-tab">
            <div className="pd-example-code">
              <Prism language="sql">{selectResponse}</Prism>
            </div>
          </Tab>
        </Tabs>
      </SmoothCollapse>
    );
  }

  // #endregion
}

// #endregion

// #region -------------- Helpers -------------------------------------------------------------------

function getCode(code: string): string {
  let c = code;
  c = c.replace(
    ` } from 'peekdata-datagateway-api-sdk'`,
    `, ReportFilterOperationType, ReportSortDirectionType, IReportRequest } from 'peekdata-datagateway-api-sdk'`
  );
  c = c.replace("dataapi.colors", colorsCode);
  c = c.replace("const request =", `const request: IReportRequest =`);
  c = c.replace("dataapi.request", requestCode);
  c = c.replace("dataapi.apiUrl", `"${dataapi.apiUrl}"`);
  c = c.replace(`import { dataapi } from 'src/constants/dataapi';\r\n`, "");
  return c.trim();
}

// #endregion
